import { HexColor } from "@/types/cssTypes";

//BUTTON COLORS
export const PRIMARY_BUTTON_COLOR: HexColor = "#FFCD4D";
export const PRIMARY_BRAND_VARIANT_COLOR: HexColor = "#FFF7E4";

export const PRIMARY_BUTTON_COLOR_HOVER: HexColor = "#F4B618";
export const PRIMARY_BUTTON_COLOR_PRESSED: HexColor = "#FFCD4D";
export const PRIMARY_BUTTON_COLOR_DISSABLED: HexColor = "#E6E7E9";

export const SECONDARY_BUTTON_COLOR: HexColor = "#FFFFFF";
export const SECONDARY_BUTTON_COLOR_HOVER: HexColor = "#FFF7E4";

export const NEUTRO_BLANK_COLOR: HexColor = "#FEFDFC";

//TEXT COLORS
export const NEUTRO_TITLES_COLOR: HexColor = "#262423";
export const NEUTRO_OVERLINE_COLOR: HexColor = "#3C3C3B";
export const NEUTRO_PARAGRAPHS_COLOR: HexColor = "#686868";
export const NEUTRO_BACKGROUND_SIDEBAR_COLOR: HexColor = "#FEFDFC";

//BORDERS COLORS
export const BORDERS_COLOR: HexColor = "#E5E5E5";
export const INPUT_BORDER_COLOR: HexColor = "#F1F1F1";
export const WHITE_BUTTON_BORDER_COLOR: HexColor = "#AAAAAA";
//STATE COLORS
export const CONFIRMATION_COLOR: HexColor = "#0D945B";
export const ERROR_COLOR: HexColor = "#CE1131";
export const ERROR_ACCENT_COLOR: HexColor = "#E31919";
export const ERROR_VARIANT_COLOR: HexColor = "#FC672F";
export const WARNING_COLOR: HexColor = "#EA9D2F";

//DIMENSIONS
export const HEADER_HEIGHT: string = "80px";

//API ERRORS
export const MAIL_ALREADY_REGISTERED: string =
  "An account with the given email already exists";
export const INVALID_VERIFICATION_CODE: string =
  "Invalid verification code provided";
export const ATTEMP_LIMIT_EXCEEDED: string = "Attempt limit exceeded";

export const FAKE_ID_FOR_EXTRA_AUDIENCE = 9999;
